import { Injectable } from '@angular/core';

import { ApiService } from './api.service';
import { CONSTANTS } from '../../constants';

@Injectable({
  providedIn: 'root'
})
export class DataCollectionService extends ApiService {

  public getCategories(data: any){
    return this.getQueryParams(CONSTANTS.API.DATA_COLLECTION.LIST_CATEGORIES, data);
  }

  public splitCategories(data: any){
    return this.getQueryParams(CONSTANTS.API.DATA_COLLECTION.SPLIT_CATEGORY, data);
  }

  public checkDataStatus(data: any){
    return this.getQueryParams(CONSTANTS.API.DATA_COLLECTION.CHECK_DATA_STATUS, data);
  }

  public runData(data: any){
    return this.getQueryParams(CONSTANTS.API.DATA_COLLECTION.RUN_DATA, data);
  }

  public stopData(data: any){
    return this.getQueryParams(CONSTANTS.API.DATA_COLLECTION.STOP_DATA, data);
  }

  public checkDataRunStatus(data: any){
    return this.getQueryParams(CONSTANTS.API.DATA_COLLECTION.CHECK_DATA_RUN_STATUS, data);
  }

  public archieveData(data: any){
    return this.getQueryParams(CONSTANTS.API.DATA_COLLECTION.ARCHIEVE_DATA, data);
  }

  public stopArchieveData(data: any){
    return this.getQueryParams(CONSTANTS.API.DATA_COLLECTION.STOP_ARCHIEVE_DATA, data);
  }

  public archieveDataRunStatus(data: any){
    return this.getQueryParams(CONSTANTS.API.DATA_COLLECTION.ARCHIEVE_DATA_RUN_STATUS, data);
  }
}
